import {FiltersModel} from '@features/search/interfaces';
import {PriceLevelSettings} from 'app/priceLevelSettings';

export function getDefaultFilters(settings: PriceLevelSettings): FiltersModel {
    return {
        brands: [],
        deliveryDayRange: {},
        priceRange: {},
        quantityRange: {},
        ratingRange: {},
        isOfficialDealer: false,
        isReturnPossible: false,
        favorite_price_list: false,
        banned_price_list: false,
        priceLevel: settings.enabled,
    };
}